import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, PriceCategoryDeleteRequest, PriceCategoryGetListRequest, PriceCategoryGetListResponse, PriceCategoryInsertRequest } from '../models';

@Injectable({
  providedIn: 'root'
})
export class PriceCategoryService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getPriceCategories(body: PriceCategoryGetListRequest) {
    const link = this.apiUrl + ApiUrls.getPriceCategories;
    return this.http.post<PriceCategoryGetListResponse>(link, body);
  }

  getPriceCategory(id: any) {
    const link = this.apiUrl + ApiUrls.getPriceCategory;
    return this.http.get<any>(link+"/"+id );
  }

  deletePriceCategory(body: PriceCategoryDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deletePriceCategory;
    return this.http.post<BaseResponse>(link, body);
  }

  insertPriceCategory(body: PriceCategoryInsertRequest) {
    const link = this.apiUrl + ApiUrls.insertPriceCategory;
    return this.http.post<BaseResponse>(link, body);
  }

  updatePriceCategory(body: PriceCategoryInsertRequest) {
    const link = this.apiUrl + ApiUrls.updatePriceCategory;
    return this.http.post<BaseResponse>(link, body);
  }
}
